"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Screen = exports.ScreenWrapper = exports.Layout = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
exports.Layout = styled_components_1.default.main `
  height: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;

  ${({ backgroundColor = '#f3f3f3' }) => backgroundColor && styled_components_1.css `
    background-color: ${backgroundColor};
  `};
`;
exports.ScreenWrapper = styled_components_1.default.div `
  width: 90%;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`;
exports.Screen = styled_components_1.default.div `
  width: 100%;
  max-width: 500px;
  height: calc(100vh - 45px);
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: 1100px) {
    margin-right: 25px;
  }

  @media screen and (max-width: 900px) {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
    margin-right: 0;
    max-width: 100%;
    height: 100vh;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  ${({ screenBackgroundColor = '#fefefe' }) => screenBackgroundColor && styled_components_1.css `
    background-color: ${screenBackgroundColor};
  `};

  ${({ screenLightShadow = '-31px -31px 62px #d9d9d9', screenDarkShadow = '-31px -31px 62px #ffffff', }) => styled_components_1.css `
    background-color: ${screenLightShadow}, ${screenDarkShadow};
  `};
`;
//# sourceMappingURL=MobileSizedView.styles.js.map